/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CreateCustomerRequestEntry } from './CreateCustomerRequestEntry.js';
import {
    CreateCustomerRequestEntryFromJSON,
    CreateCustomerRequestEntryFromJSONTyped,
    CreateCustomerRequestEntryToJSON,
} from './CreateCustomerRequestEntry.js';

/**
 * 
 * @export
 * @interface UpdateCustomerDetailsRequest
 */
export interface UpdateCustomerDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerDetailsRequest
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerDetailsRequest
     */
    statusId?: number;
    /**
     * 
     * @type {Array<CreateCustomerRequestEntry>}
     * @memberof UpdateCustomerDetailsRequest
     */
    entries?: Array<CreateCustomerRequestEntry>;
}

/**
 * Check if a given object implements the UpdateCustomerDetailsRequest interface.
 */
export function instanceOfUpdateCustomerDetailsRequest(value: object): boolean {
    return true;
}

export function UpdateCustomerDetailsRequestFromJSON(json: any): UpdateCustomerDetailsRequest {
    return UpdateCustomerDetailsRequestFromJSONTyped(json, false);
}

export function UpdateCustomerDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCustomerDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(CreateCustomerRequestEntryFromJSON)),
    };
}

export function UpdateCustomerDetailsRequestToJSON(value?: UpdateCustomerDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'externalId': value['externalId'],
        'statusId': value['statusId'],
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(CreateCustomerRequestEntryToJSON)),
    };
}

